module.exports = __webpack_public_path__ + "media/images/flags/dk-7b602d3e01d20b25965fe614f7ee170a.svg";